module.exports = __webpack_public_path__ + "img/4@2x.73985027.png";